import { addDaysUtc, dayOfWeekUTC, daysInMonth } from '../../../utils/date';

export function monthLabel(year, month) {
  return `${year}년 ${month}월`;
}

export function monthKey(year, month) {
  return `${year}-${String(month).padStart(2, '0')}`;
}

export function shiftMonth(year, month, delta) {
  const zeroBased = (Number(year) * 12) + (Number(month) - 1) + delta;
  const nextYear = Math.floor(zeroBased / 12);
  const nextMonth = (zeroBased % 12) + 1;
  return { year: nextYear, month: nextMonth };
}

export function rowDraftFromWeek(week) {
  const assignment = week.assignment || {};
  return {
    id: assignment.id || null,
    week_start: week.week_start,
    week_end: week.week_end,
    user_id: assignment.user_id ? String(assignment.user_id) : '',
  };
}

export function buildMonthCalendar(year, month) {
  const pad = (value) => String(value).padStart(2, '0');
  const first = `${year}-${pad(month)}-01`;
  const lastDay = daysInMonth(year, month);
  const leading = dayOfWeekUTC(first);
  const cells = [];

  for (let i = 0; i < leading; i += 1) cells.push(null);
  for (let day = 1; day <= lastDay; day += 1) {
    const date = `${year}-${pad(month)}-${pad(day)}`;
    cells.push({ date, day, dow: dayOfWeekUTC(date) });
  }
  while (cells.length < 42) cells.push(null);
  return cells.slice(0, 42);
}

export function weekKeyForDate(date) {
  const dow = dayOfWeekUTC(date);
  if (dow === 6) return date;
  if (dow === 0) return addDaysUtc(date, -1);
  return null;
}
